module.exports = __webpack_public_path__ + "static/media/40.f0ed048f.svg";